function getViteEnvVars() {
    if (typeof window !== 'undefined' && window.__ENV__) {
        return window.__ENV__;
    }
    if (typeof globalThis !== 'undefined' &&
        globalThis.process?.env) {
        return globalThis.process
            .env;
    }
    if (typeof window !== 'undefined' && import.meta?.env) {
        return import.meta.env;
    }
    return {};
}
export const ENV_VARS = getViteEnvVars();
